import classNames from 'classnames';
import PropTypes from 'prop-types';

const HeadsetIcon = ({ className, width = '24' }) => {
  return (
    <svg
      className={classNames('headset-icon', className)}
      width={width}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M4.86682 9.47658C4.48934 9.65491 4.3006 9.74407 4.20271 9.66357C4.10483 9.58306 4.15078 9.40094 4.24269 9.03669C5.11795 5.56763 8.25912 3 12 3C15.7409 3 18.8821 5.56764 19.7573 9.03669C19.8492 9.40094 19.8952 9.58306 19.7973 9.66357C19.6994 9.74407 19.5107 9.65491 19.1332 9.47658C18.4862 9.17093 17.763 9 17 9C15.3431 9 14 10.3431 14 12V16C14 17.6569 15.3431 19 17 19C19.7614 19 22 16.7614 22 14V11C22 5.47715 17.5228 1 12 1C6.47715 1 2 5.47715 2 11V14C2 16.7614 4.23858 19 7 19C8.65685 19 10 17.6569 10 16V12C10 10.3431 8.65685 9 7 9C6.23695 9 5.51383 9.17093 4.86682 9.47658Z'
        fill='currentColor'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M21 13C21.5523 13 22 13.4477 22 14V15.8845C22 16.8561 22 17.6399 21.9533 18.2766C21.9052 18.9317 21.8037 19.5095 21.5595 20.0521C21.0581 21.1661 20.1661 22.0581 19.0521 22.5595C18.5095 22.8037 17.9317 22.9052 17.2766 22.9533C16.6399 23 15.8561 23 14.8845 23H12C11.4477 23 11 22.5523 11 22C11 21.4477 11.4477 21 12 21H14.8462C15.8651 21 16.5753 20.9994 17.1302 20.9586C17.6751 20.9186 17.9908 20.8439 18.2312 20.7357C18.8997 20.4349 19.4349 19.8997 19.7357 19.2312C19.8439 18.9908 19.9186 18.6751 19.9586 18.1302C19.9994 17.5753 20 16.8651 20 15.8462V14C20 13.4477 20.4477 13 21 13Z'
        fill='currentColor'
      />
    </svg>
  );
};

HeadsetIcon.propTypes = {
  className: PropTypes.string,
  width: PropTypes.string,
};

export default HeadsetIcon;
